import { render } from "./PatientHealthHistory.vue?vue&type=template&id=6b52e2de&ts=true"
import script from "./PatientHealthHistory.ts?vue&type=script&lang=ts&external"
export * from "./PatientHealthHistory.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__